import { html } from "lit";
import { unsafeHTML } from "lit/directives/unsafe-html.js";
import { until } from "lit/directives/until.js";
import { ASSET_URL_PREFIX } from "../config/assets.js";

const cache = new Map();

async function fetchSvg(name) {
  if (cache.has(name)) return cache.get(name);
  const res = await fetch(`${ASSET_URL_PREFIX}/img/icons/${name}.svg`);
  const text = await res.text();
  cache.set(name, text);
  return text;
}

export function svgIcon(name) {
  return until(
    fetchSvg(name).then((svg) => html`${unsafeHTML(svg)}`),
    html``,
  );
}
